module.exports = require('react/lib/ReactFragment').create;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-addons-create-fragment/index.js
// module id = 712
// module chunks = 0